<template>
    <div class="error text-dark">
		<div>{{ message }}</div>
		<div v-if="code != null" class="error-id text-muted">Код ошибки: {{ code }}</div>
		<span class="error-dismiss" @click="$emit('delete')">&nbsp;<fa icon="xmark"/></span>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import Fa from '@/components/mdbvue/Content/Fa.vue'

export default defineComponent({
	name: 'Error',
	components: { Fa },
	props: {
		code: {
			type: [ String, Number ],
			required: false,
		},
		message: {
			type: String,
			required: false
		}
	},
	emits: [ 'delete' ],
})
</script>

<style scoped>
.error-dismiss {
	cursor: pointer;
}

.error-id {
	font-size: 0.875rem;
	margin-top: 0.25rem;
}
</style>
